let jumpTo;

window.flickities = {};

var doc = document.documentElement;
var prevScroll = window.scrollY || doc.scrollTop;
var curScroll;
var direction = 0;
var prevDirection = 0;
var header = document.getElementsByTagName("header")[0];
var toggledYet = false;
var checkScroll = function () {
  $(".link-hover, .button-hover").removeClass("link-hover button-hover");
  curScroll = window.scrollY || doc.scrollTop;
  direction = curScroll > prevScroll ? 2 : 1;
  if (direction !== prevDirection) {
    toggleHeader(direction, curScroll);
  }
  if (curScroll === 0) {
    header.classList.remove("scrolled");
    toggledYet = false;
  }
  prevScroll = curScroll;
};

window.addEventListener("scroll", checkScroll, { passive: true });
var crazyInterval;
var colors = ["red", "blue", "yellow", "orange"];
var toggleHeader = function (direction, curScroll) {
  if (direction === 2 && curScroll > 118) {
    header.classList.add("hide");
    if (!toggledYet) {
      setTimeout(function () {
        header.classList.add("scrolled");
        toggledYet = true;
      }, 300);
    }
    prevDirection = direction;
  } else if (direction === 1) {
    header.classList.remove("hide");
    header.classList.add("crazy");
    setTimeout(function () {
      header.classList.remove("crazy");
    }, 3000);
    prevDirection = direction;
  }
};
var cursor = document.getElementById("cursor-overlay");
var links = document.querySelectorAll("a");

let quantityUpdate;

var lazyLoadInstance = new LazyLoad({
  unobserve_entered: false,
  threshold: 1000,
});
window.lazyLoadInstance = lazyLoadInstance;

var url = new URL(window.location.href);
//if variant param present, act as if the corresponding color label was clicked
if (url.searchParams.get("variant")) {
  switchVariant(url.searchParams.get("variant"));
} else if (window.slj_variants) {
  switchVariant(slj_variants[0]);
}
var variantQuantityAvailable;
var currentVariant;

//works on thumbnails and product pages
function switchVariant(id) {
  let givenVariant = id;
  let hasColorOption = pr_current_product.options.length
    ? pr_current_product.options[0] === "Shade" ||
      pr_current_product.options[0] === "Color"
    : false;
  //if color option is present, get the first variant id with the same color as the chosen variant
  if (hasColorOption) {
    //get the first variant id with the same color as the chosen variant
    let color = pr_current_product.variants.filter(function (v) {
      return v.id === parseInt(id);
    })[0].option1;
    let idz = pr_current_product.variants.find(function (v) {
      return v.option1 === color;
    }).id;
  }
  let old_variant = parseInt(currentVariant);
  currentVariant = id;
  //deselect chosen variant
  //get image from containing product-images element
  //URL PARAM!
  var url = new URL(window.location.href);
  var search_params = url.searchParams;

  // new value of "id" is set to "101"
  search_params.set("variant", id);

  // change the search property of the main url
  url.search = search_params.toString();
  console.log("new url", url.toString());
  // the new url string
  let newUrl = url.toString();

  let sameColor;
  // is the current choice the same color as the previous choice? if so, don't change the url
  console.log({
    old_variant,
    currentVariant,
  });
  if (hasColorOption) {
    sameColor =
      old_variant &&
      pr_current_product.variants.filter(function (v) {
        return v.id === id;
      })[0].option1 ===
        pr_current_product.variants.filter(function (v) {
          return v.id === old_variant;
        })[0].option1;
  }

  //

  // output : http://demourl.com/path?id=101&topic=main
  // console.log(new_url);
  //URL PARAM!
  $(".variant-title-option.current").removeClass("current");
  //not sure what this is
  $(".variant-title-option[data-variant-id='" + id + "']").addClass("current");
  var imgs = $(
    ".product-images .hide-variant-image[data-variant-image=" + id + "]",
  )
    .removeClass("hide-variant-image")
    .map(function (i, e) {
      return $(e).attr("data-img-src");
    });
  $(".hide-variant-image").remove();
  //$(".hide-variant-image").hide()
  console.log("This many images: ", imgs.length);
  var newImg = new Image();
  newImg.onload = function () {
    $(".page-carousel-image:eq(0)").css(
      "background-image",
      "url(" + imgs[0] + ")",
    );
    $(".product-image-wrapper").addClass("active");
    console.log("loaded new img");
  };
  newImg.src = imgs[0];

  if (
    !sameColor &&
    (pr_current_product.options[0] === "Color" ||
      pr_current_product.options[0] === "Shade") &&
    window.location.href !== newUrl
  ) {
    //if we're changing colors, change the URL causing a refresh
    window.location.href = url.toString();
  } else {
    let options = $(".variant-picker")
      .map((i, e) => {
        $(e)
          .parent()
          .find(".custom-select-opener span")
          .attr("data-color", $(e).val());
        return $(e).val();
      })
      .toArray();
    let queryString = options
      .map((o, i) => `[data-option-${i + 1}='${o}']`)
      .join("");
    let index = $(".page-carousel-image" + queryString).index();
    console.log("ok... ", flickities);

    if (window.flickities && window.flickities.hasOwnProperty("0")) {
      console.log("we should select", index, queryString);
      setTimeout(() => {
        window.flickities[0].select(index);
      }, 10);
    }
  }
  // console.log({givenVariant,old_variant})
  $("#add-to-cart").attr("data-variant", givenVariant);
  var availableHandle = `data-variant-${givenVariant}-available`;
  var compareAtHandle = `data-variant-${givenVariant}-compare-at`;
  var preorderHandle = `data-variant-${givenVariant}-preorder`;
  var priceHandle = `data-variant-${givenVariant}-price`;
  // console.log("switching variant",`#product-form[data-variant-${id}-available]`)
  //Check if available
  if ($("#add-to-cart").hasClass("inquire")) {
  } else if ($(`#product-form[${availableHandle}]`).length) {
    variantQuantityAvailable = parseInt(
      $(`#product-form[${availableHandle}]`).attr(availableHandle),
    );
    // console.log("available = ",variantQuantityAvailable)
    if ($("#product-form").attr(preorderHandle)) {
      console.log("added", $("#product-form").attr(preorderHandle));
      $("#add-to-cart").attr(
        "data-preorder",
        $("#product-form").attr(preorderHandle),
      );
    }
    $("#add-to-cart").text(
      $("#add-to-cart").attr("data-preorder") ? "Pre-order" : "Add TO CART",
    );
    $("#add-to-cart").addClass("available");
    $("#BIS_trigger_button").addClass("hidden");
    $("#add-to-cart").removeClass("hidden");
  } else {
    $("#add-to-cart").text("SOLD OUT");
    $("#add-to-cart").addClass("soldout");
    $("#add-to-cart").addClass("hidden");
    $("#BIS_trigger_button").removeClass("hidden");
  }
  //Get the price, and compare at price
  let priceHtml;
  if ($(`#product-form[${compareAtHandle}]`).length) {
    priceHtml = `<span class="price-varies">
      <span class="compare-at">
        <span class="bar"></span>${$("#product-form").attr(compareAtHandle)}</span>
      <span class="price">
        ${$("#product-form").attr(priceHandle)}
      </span>
      `;
  } else {
    priceHtml = $("#product-form").attr(priceHandle);
  }
  $("#product-price").html(priceHtml);

  // console.log("switching to ",id)
  //if we had to jump to another variant than what we picked, see if we can scroll to the picked variant image
  if (id !== givenVariant) {
    let variant = pr_current_product.variants.filter(function (v) {
      return v.id === parseInt(givenVariant);
    })[0];
    console.log("actual variant ", variant);
  }
}

var slj_filter = {
  style: "",
  collection: "",
};

function setRecommended() {
  if (!window.pr_all_products) return;
  var products = pr_all_products
    .filter(
      (p) =>
        p.handle.indexOf("test") === -1 && p.title !== pr_current_product.title,
    )
    .filter((p) => p.type === pr_current_product.type)
    .filter((p) => !!p.featured_image)
    .sort(() => (Math.random() > 0.5 ? 1 : -1))
    .slice(0, 4);
  if (products.length === 0) {
    let offset = Math.floor(Math.random() * (pr_all_products.length - 3));
    products = pr_all_products.slice(offset, offset + 3);
  }
  var filteredVariants = pr_current_product
    ? pr_current_product.variants.filter(
        (v) => v.id !== parseInt(currentVariant),
      )
    : products[0].variants.filter((v) => v.id !== parseInt(currentVariant));
  if (filteredVariants.length > 1) {
    let p = pr_current_product ? pr_current_product : products[0];
    var copy1 = { ...p };
    copy1.variants = [filteredVariants[0]];
    var copy2 = { ...p };
    copy2.variants = [filteredVariants[1]];
    products[0] = copy1;
    products[1] = copy2;
  }
  renderRecommended(products);
  lazyLoadInstance.update();
}

function renderRecommended(products) {
  let slots = $(".prdct-recommendations .shop-thumb");
  slots.each(function (i, slot) {
    var product = products[i] ? products[i] : products[i - 1];
    console.log(products);
    if (!product) {
      console.log(product, variant);
      return;
    }
    var variant =
      product.variants[Math.floor(Math.random() * product.variants.length)];
    $(slot).attr("href", `/products/${product.handle}?variant=${variant.id}`);
    let img = variant.featured_image?.src.replace(".jpg", "_800x800.jpg");
    if (!!!img) {
      img = product.featured_image.replace(".jpg", "_800x800.jpg");
    }
    // console.log("recommended variant",variant,product)
    $(slot).find(".thumb-image").attr("data-bg", img);
    $(slot).find(".thumb-title").text(product.title);
    if (
      product.options &&
      product.options.length < 2 &&
      variant.title !== "Default Title"
    ) {
      $(slot).find(".thumb-variant-title").text(variant.title);
    }
    $(slot)
      .find(".thumb-price")
      .text(variant.available ? "$" + variant.price / 100 : "SOLD OUT");
    if (!variant.available)
      $(slot).find(".thumb-price").addClass("thumb-sold-out");
  });
}

function addEventListenerList(list, event, fn) {
  for (var i = 0, len = list.length; i < len; i++) {
    if (event === "click" && window.innerWidth < 480) return;
    list[i].addEventListener(event, fn, { passive: true });
  }
}

// setRecommended();

//Adjusting fullscreen-sized elements for mobile...

if (window.innerWidth < 480) {
  $(".feature").map((i, e) => {
    $(e).height(window.innerHeight);
    $(e).find(".mobile-feature-img,.feature-img").height(window.innerHeight);
  });
}
$(".the-product-form #BIS_trigger_button").click(function (e) {
  $(".BIS_trigger:eq(0)").click();
});
if (window.innerWidth > 480) {
  $(".video-button").click(function (e) {
    let wrapper = $(e.target).closest(".video-section-wrapper");
    let playing = wrapper.hasClass("playing");
    console.log("playing? ", playing);
    var video = $(e.target).next();
    if (!playing) {
      video[0].play();
    } else {
      video[0].pause();
    }
    wrapper.toggleClass("playing paused");
  });
} else {
  //
  // $(".video-section-wrapper").click(function(e){
  //   let wrapper = $(e.target).hasClass(".video-section-wrapper") ?  $(e.target) : $(e.target).closest(".video-section-wrapper");
  //   var video = wrapper.find("video");
  //   console.log(wrapper)
  //   let playing = video[0].paused;
  //   console.log("playing? ",playing,wrapper,video)
  //   if(!playing){
  //     video[0].play();
  //   } else {
  //     video[0].pause();
  //   }
  //   wrapper.toggleClass("playing paused")
  // })

  //add a controls atrribute to any video in a video-section-wrapper
  $(".video-section-wrapper video").attr("controls", "controls");
  // $(".video-section-wrapper video").attr("preload","auto")
  //hide play buttons on mobile
  $(".video-section-wrapper .video-button").hide();
  //set current time to 0.1 milliseconds and then pause

  //set videos "mobile-poster" attribute as the "poster" attribute
  $(".video-section-wrapper video").each((i, e) => {
    $(e).attr("poster", $(e).attr("mobile-poster"));
    console.log(
      "updating poster",
      $(e).attr("mobile-poster"),
      $(e).attr("poster"),
    );
  });
  // $(".video-section-wrapper video").each((i,e)=>{
  //   e.currentTime = 0.1;
  //   e.pause();
  // })
}

var popup_history = {};
var popup_wait_time = 3600000; // 1 hour

function getPopupHistory() {
  var raw = localStorage.getItem("slj_popup_history");
  if (raw && raw.indexOf(",") > -1) {
    var popups = raw.split(",").filter((item) => item.indexOf(":") > -1);
    for (var i = 0; i < popups.length; i++) {
      var keyVal = popups[i].split(":");
      popup_history[keyVal[0]] = keyVal[1];
    }
  }
}

function setPopupHistory(name) {
  var str = "";
  for (var i in popup_history) {
    str += `${i}:${popup_history[i]},`;
  }
  str += `${name}:${Date.now()},`;
  localStorage.setItem("slj_popup_history", str);
}

getPopupHistory();

function userShouldSeePopup(name) {
  getPopupHistory();
  if ($("#popup").hasClass("test-true")) return true;

  if (popup_history[name]) {
    var elapsed = Date.now() - parseInt(popup_history[name]);
    if (elapsed < popup_wait_time) {
      // if less than 5 mins passed
      console.log(`popup '${name}' seen less than ${popup_wait_time} ms ago.`);
      return false;
    }
  }
  return true;
}

function togglePopup() {
  $("body").toggleClass("popup-showing");
  $("#popup").toggleClass("hidden");
}

function setPopup() {
  var popup = $("#popup");
  var name = popup.attr("data-name");
  if (!userShouldSeePopup(name)) return;

  setPopupHistory(name);
  togglePopup();
  $("#popup-x").click(togglePopup);
}

$("#popup .backdrop").click(function (e) {
  e.preventDefault();
  $("#popup").toggleClass("hidden");
  $("body").removeClass("popup-showing");
});
let popped = false;
if ($("#popup").attr("data-delay")) {
  setTimeout(setPopup, parseInt($("#popup").attr("data-delay")) * 1000);
} else if ($("#popup").attr("data-scroll")) {
  let popup = $("#popup");
  //add an scroll listener that calls setPopup when users scrolls 30% down the page
  window.addEventListener("scroll", function (e) {
    // console.log(window.scrollY, document.body.scrollHeight*(popup.attr("data-scroll")/100))
    if (
      !popped &&
      window.scrollY >
        document.body.scrollHeight * (popup.attr("data-scroll") / 100)
    ) {
      // console.log("LETS DO IT!")
      setPopup();
      popped = true;
      window.removeEventListener("scroll", this, false);
    }
  });
}

$(document).ready(function () {
  console.log($(".shop-thumb"));
  //for each shop-thumb, add an event listener for mouse enter that logs hello
  $(".shop-thumb").each((i, e) => {
    // console.log(e)
    e.addEventListener("mouseenter", function (e) {
      console.log("mouseenter");
      let video = $(e.target).closest(".shop-thumb").find("video")[0];
      if (video) {
        video.play();
      }
    });
    // e.addEventListener('mouseleave', function(e){
    //     let video = $(e.target).closest(".shop-thumb").find("video")[0];
    //     if(video){
    //     video.pause();
    //     video.currentTime = 0;
    //     }
    // })
  });

  //remove previously hoverd items
  $(".link-hover, .button-hover").removeClass("link-hover button-hover");

  //outbound links in new tab
  $("a").each(function (i, e) {
    if (!$(e).attr("href") || $(e).attr("href").length < 2) return;

    var link = $(e).attr("href");
    //console.log("link: ",link)
    if (link.indexOf("http") > -1) $(e).attr("target", "_blank");
  });
  //Mailchimp form submit code
  var mailchimp = $(".mc-embedded-subscribe-form");
  $(mailchimp)
    .find("[type='submit']")
    .bind("click", function (e) {
      console.log("submitting ", mailchimp.serialize());
      var parentForm = $(this).closest("form");
      e.preventDefault();
      $.ajax({
        type: mailchimp.attr("method"),
        url: mailchimp.attr("action"),
        data: parentForm.serialize(),
        cache: false,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        error: function (err) {
          $("#mce-responses").addClass("error error2");
        },
        success: function (data) {
          console.log("mailchimp data:");
          console.log(data);
          if (data.result != "success") {
            if (data.msg.indexOf("already subscribed")) {
              parentForm.find(".mce-responses").removeClass("success error");
              parentForm.find(".mce-responses").addClass("already");
            } else {
              parentForm.find(".mce-responses").addClass("error error1");
              parentForm.find(".mce-responses").removeClass("already success");
            }
          } else {
            parentForm.find(".mce-responses").addClass("success");
            parentForm
              .find(".mce-responses")
              .removeClass("already error error1");
          }
        },
      });
    });
  //start custom select
  // Legacy customSelect plugin variant picker — replaced by the vanilla
  // .pdp-picker built in src/js/main.js. The old .change handler also had a
  // key-format bug (.join("") produced "ClearSmall" but the lookup map keys
  // were '["Clear", "Small"]') so variant switching from the picker never
  // actually worked anyway.
  /* removed:
    var productPage = $("#variant-select").length;
    let cstSel = $(".variant-picker").customSelect({ transition: 400 });
    $(".variant-picker").each(...);
    $(".variant-picker").change(...);
  */
  let dropdownLabels = document.querySelectorAll(".custom-select-opener span");
  let productInfo = document.querySelector(".product-info");
  const sizeDropdowns = () => {
    // console.log("efffff",dropdownLabels)
    let width = productInfo.getBoundingClientRect().width;
    for (var i = 0; i < dropdownLabels.length; i++) {
      let el = dropdownLabels[i];
      el.style.width = `${width - 52}px`;
      // console.log("hey",el)
    }
  };

  //addEventListener("resize",sizeDropdowns)
  if (!!productInfo) sizeDropdowns();
  //end custom select

  if ($(".page-carousel").length) {
    jumpTo = Math.max($(`[data-the-variant=${currentVariant}]`).index(), 0);
    flickities = $(".page-carousel").map(function (i, el) {
      $(el).closest(".loadable").addClass("loaded");

      return new Flickity(el, {
        // options
        selectedAttraction: 0.2,
        friction: 0.8,
        cellAlign: "left",
        setGallerySize: false,
        contain: true,
        initialIndex: jumpTo ? jumpTo : 0,
      });
    });
    flickities.each((i, fl) => {
      let el = $(fl.element);
      console.log(el, fl.slides.length);
      el.parent().find(".pag-total").text(fl.slides.length);
      el.parent()
        .find(".pag-current")
        .text(jumpTo + 1);
      fl.on("change", function (index, e) {
        let el = $(fl.element);
        console.log(el, index, fl.slides.length);
        el.parent()
          .find(".pag-current")
          .text(index + 1);
        el.parent().find(".pag-total").text(fl.slides.length);
      });
    });
    console.log("created flickities");
    //get current selected options
    console.log("jumping to ", jumpTo);
    if (jumpTo) {
      // flickities[0].options.selectedAttraction =  0;
      // flickities[0].options.friction =  0;
      // flickities[0].select(jumpTo);
      console.log("trying this");
      setTimeout(() => {
        flickities[0].options.selectedAttraction = 0.2;
        flickities[0].options.friction = 0.8;
      }, 1000);
    }
    $(".flickity-button").append("<div class='button-arrow'></div>");
  }

  $(".title-container h1").addClass("ready-to-animate");

  //$(".product-variantz").selectmenu({
  //classes: {
  //"ui-selectmenu-button": "variant-selector",
  //"ui-selectmenu-menu": "variant-options"
  //},
  //change: function(event,ui){
  //console.log(event,ui)
  //console.log("The value is: ",ui.item.value)
  //switchVariant(ui.item.value)
  //}
  //})

  // Mobile menu (.main-menu) is now handled in main.js (body.menu-open).
  // The legacy openNav below added body.nav-open — which the cart drawer also
  // uses — so it's disabled to avoid the two fighting over that class.
  // var navs = document.querySelectorAll(".main-menu");
  // const openNav = (e) => { ... $(`body,#nav-main-menu`).toggleClass("nav-open"); ... };
  // addEventListenerList(navs, "touchstart", openNav);
  // addEventListenerList(navs, "click", openNav);

  // Cart open/close, PDP add-to-cart, quick-add, cart quantity controls,
  // and upsell add buttons are now handled in src/js/main.js (window.SLJCart).
  // Legacy bindings disabled below to avoid double-firing.

  // var cartToggle = document.querySelectorAll(".cart-toggle, .header-item.cart")
  // const toggleCart = (e) => { openCart() };
  // function initCartToggles(){ $(document).on("click",".cart-toggle, .header-item.cart",toggleCart); }
  // initCartToggles();

  // $(document).on("click",".nav-x, .blurred-background",closeCart);

  // var addToCartButton = document.querySelectorAll("#add-to-cart");
  // function addButtonClicked(e){ ... }
  // addEventListenerList(addToCartButton,"click",addButtonClicked)
  // addEventListenerList(addToCartButton,"touchstart",addButtonClicked)
  // PDP qty +/- handlers — now owned by main.js (delegated on
  // .pdp-qty-row .q-control). The legacy markup wrapped qty in
  // .the-product-form .item-quantity, which doesn't exist in the new
  // PDP. Leaving this block neutralised so we don't double-bind or
  // throw on the missing data-og-price slice.

  // Cart drawer quantity controls now handled in main.js (SLJCart.changeItem)
  // var qControl = document.querySelectorAll('#cart .q-control')
  // quantityUpdate = (e) => { ... }
  // $(document).on("click","#cart .q-control",quantityUpdate)

  if (window.location.href.indexOf("view-cart") > -1) {
    toggleCart();
  }
  if ($("#admin-bar-iframe").length) {
    $(".admin-info").addClass("showing");
  }
  $(".hide-admin").click(function () {
    $(".admin-info").removeClass("showing");
  });

  $("#shop-page-filter").click(() => {
    $(".shop-dropdowns").toggleClass("active");
  });

  $(".mobile-collections-toggle").click(() => {
    $(".outbound.mobile,.mobile-collections-toggle").toggleClass("active");
  });

  $(
    ".shop-section .collection-dropdown .dropdown-item,.shop-section .filter .dropdown-item",
  ).click(function (e) {
    return;
    e.preventDefault();
    e.stopPropagation();
    let target = $(e.target);
    let el = target.attr("data-c") ? target : target.parent();
    let collection = el.attr("data-c");
    $(`.shop-thumb.active`).removeClass("active");
    $(`.shop-thumb[collection-${collection}]`).addClass("active");
    $("#shop-scroll, #shop-page-filter").addClass("filtering");
    $("#filtered-by").text(collection.split("-").join(" "));
    $(".shop-dropdowns").removeClass("active");

    //"unhover" by hiding and reshowing after
    //el.closest(".dropdown-list").hide();
    //setTimeout(function(){
    //el.closest(".dropdown-list").show();
    //},500)
  });
  //cancelling filter
  $(document).on("click", "#shop-page-filter.filtering", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(`.shop-thumb`).addClass("active");
    $("#shop-scroll, #shop-page-filter").removeClass("filtering");
    $("#filtered-by").text("");
    $(".shop-dropdowns").removeClass("active");

    //"unhover" by hiding and reshowing after
    //el.closest(".dropdown-list").hide();
    //setTimeout(function(){
    //el.closest(".dropdown-list").show();
    //},500)
  });

  if ($(".shop-thumb").length) {
    let allProducts = [];
    if (false)
      $(".shop-thumb").each(function (i, e) {
        let id =
          $(e).find(".thumb-title").text() +
          $(e).find(".thumb-variant-title").text();
        if (allProducts.indexOf(id) > -1) {
          $(e).remove();
        } else {
          allProducts.push(id);
        }
      });
  }

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  if (params.collection) {
    console.log(params.collection);
    $(`[data-c=${params.collection}]`).click();
  }
  $(document).on("click", ".custom-select-option", (e) => {
    let container = $(e.target).closest(".custom-select-container");
    container
      .find(".custom-select-opener > span")
      .attr("data-color", $(e.target).text());
  });
  $(document).on("click", ".is-open .custom-select-option", (e) => {
    let container = $(e.target).closest(".custom-select-container");
    container.removeClass("is-open");
  });

  $(document).on("change", "#is-gift", (e) => {
    let giftBox = $("#gift-note");
    let { checked } = $(e.target)[0];
    console.log("setting up the listener", checked);
    // CartJS.setAttributes({
    //   "Is A Gift": checked
    // });
    if (checked) {
      giftBox.removeClass("hide");
    } else {
      giftBox.addClass("hide");
      CartJS.setNote("");
      // CartJS.setAttributes({"Gift Note":""});
      $("#g-note").val("");
    }
  });

  // Log the value of #g-note when it loses focus
  $(document).on("blur", "#g-note", function (e) {
    // Only update CartJS note if #gift-note is visible (doesn't have class "hide")
    if (!$("#gift-note").hasClass("hide")) {
      let message = $("#g-note").val();
      CartJS.setNote(message);
    }
    let message = $("#g-note").val();
    CartJS.setNote(message);
  });

  // Delegated on document so it survives cart re-renders. The new cart module
  // (main.js swapCartHTML) replaces the cart's innerHTML, which would destroy a
  // direct binding to #gift-note-update. Matches the #is-gift / #g-note handlers above.
  $(document).on("click", "#gift-note-update", (e) => {
    let message = $("#g-note").val();
    CartJS.setNote(message);
    // CartJS.setAttributes({"Gift Note":message});
    $("#gift-note-update").text("Updating...");
    setTimeout(() => {
      $("#gift-note-update").text("Updated!");
    }, 300);
    setTimeout(() => {
      $("#gift-note-update").text("Update");
    }, 1300);
  });
  $("#g-note").val(CartJS.getNote());

  $(".preview-video, .preview-video-unmute").click(function (e) {
    let parent = $(e.target).closest(".general-preview-wrapper");
    let muted = $(parent).find(".preview-video-unmute").hasClass("muted");
    let video = $(parent).find("video")[0];
    console.log({ video, yah: $(e.target).find(".preview-video-unmute") });
    if (muted) {
      video.muted = false;
      $(parent).find(".preview-video-unmute").removeClass("muted");
    } else {
      video.muted = true;
      $(parent).find(".preview-video-unmute").addClass("muted");
    }
  });

  $(document).on("click", ".more-info", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
  });

  // .quick-add (product grid quick-add) now handled in main.js (SLJCart)

  $(document).on(
    "click",
    "#back-link, .breadcrumb a, .back-to-collection",
    function (e) {
      e.preventDefault();
      const breadcrumb = e.target;

      if (breadcrumb) {
        const href = breadcrumb.getAttribute("href");
        console.log(
          "hey it worked",
          document.referrer,
          href,
          document.referrer.includes(href),
        );

        // Check if the referrer matches this link's destination
        if (document.referrer.includes(href)) {
          e.preventDefault();
          history.back();
        } else {
          window.location.href = href;
        }
      }
    },
  );

  (function () {
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.has("waitlist")) {
        const openKlaviyo = () => {
          const btn = document.querySelector(
            "#klaviyo-bis-button-container button",
          );
          if (btn) {
            btn.click();
            return true;
          }
          return false;
        };
        // try immediately, otherwise try again after 2s
        if (!openKlaviyo()) {
          setTimeout(openKlaviyo, 1000);
        }
      }
    } catch (e) {
      // silent fail
    }
  })();

  $(".upsell-x").click(function (e) {
    $(this).closest("#cart-upsells").remove();
  });
  // .cart-upsell-item click now handled in main.js (SLJCart.addItem)
});

//end ready

// prevent parent link from being followed when clicking the Klaviyo BIS trigger inside a .shop-thumb
$(document).on("click", ".shop-thumb .klaviyo-bis-trigger", function (e) {
  e.preventDefault();
  e.stopPropagation();
});

// also guard touch interactions on mobile
$(document).on("touchend", ".shop-thumb .klaviyo-bis-trigger", function (e) {
  e.preventDefault();
  e.stopPropagation();
});

function addOrUpdateUrlParam(name, value) {
  var href = window.location.href;
  var regex = new RegExp("[&\\?]" + name + "=");
  if (regex.test(href)) {
    regex = new RegExp("([&\\?])" + name + "=\\d+");
    window.location.href = href.replace(regex, "$1" + name + "=" + value);
  } else {
    if (href.indexOf("?") > -1)
      window.location.href = href + "&" + name + "=" + value;
    else window.location.href = href + "?" + name + "=" + value;
  }
}

function closeCart() {
  $(".nav-open").removeClass("nav-open");
  setTimeout(function () {
    $(".nav, #cart").removeClass("nav-active");
  }, 300);
}

function openCart() {
  $("#cart").addClass("nav-active");
  $(`body, #cart`).toggleClass("nav-open");
  //   setTimeout(()=>{
  //     $(".shipping-bar-meter-fill").css("width",$("#shipping-bar").attr("data-fill-width")+"%");
  //   },600)
}

function incrementCartCount() {
  var text = $("#cart-count").text();
  let result;
  if (text === "") {
    $("#cart-count").text("(1)");
    return;
  }
  var count = parseInt($("#cart-count").text());
  if (!!count) {
    $("#cart-count").text(count + 1);
  } else {
    $("#cart-count").text(1);
  }
  $("#cart-count").text(result);
}

function decrementCartCount() {
  var count = parseInt($("#cart-count").text());
  if (!!count && count > 0) {
    $("#cart-count").text(count - 1);
  } else {
    //$("#cart-count").text(1)
  }
}

function appendLineItem(d) {
  let price = CartJS.cart.total_price;
  //if variant id already in cart, just increment count
  if ($(`[cart-item-variant-id='${d.variant_id}']`).length) {
    console.log("already in cart");
    $(`[cart-item-variant-id='${d.variant_id}'] .q-value`).text(d.quantity);
    console.log("setting new price", price, d.price, d.quantity);
    $(".subtotal").text(`$${(price + d.price * d.quantity) / 100}.00`);
    console.log(CartJS.total_price);
    return;
  }
  $(".cart-items").append(`
  <div class="cart-item" cart-item-variant-id='${d.variant_id}'>
    <a href="${d.product_url}" class="cart-item-image" style="background-image: url(${d.image})">  </a>
    <div class="cart-item-info">
      <div class="cart-item-info-static">
        <a href="${d.product_url}" class="cart-item-title"> ${d.product_title} </a>
        ${$("#add-to-cart").attr("data-preorder") ? `<div class="cart-item-preorder">Preorder (delivering ${$("#add-to-cart").attr("data-preorder")})</div>` : ""}
        <div class="cart-item-variant"> ${d.variant_title ? d.variant_title : ""} </div>
      </div>
      <div class="cart-item-quantity"> <button class="q-control q-control-minus">−</button><div class="q-value">${d.quantity}</div><button class="q-control q-control-plus">+</button></div>
    </div>
    <div class="cart-item-final-price">$${d.final_price / 100}.00</div>
  </div>
  `);
  $(".subtotal").text(`$${(price + d.price * d.quantity) / 100}.00`);
  console.log(CartJS.cart.total_price);
  var qControl = document.querySelectorAll(".q-control");
  addEventListenerList(qControl, "click", quantityUpdate);
  addEventListenerList(qControl, "touchstart", quantityUpdate);
  $("#gift-note-wrapper").removeClass("hide");
}

// setupCart()/appendLineItem caused subtotal inflation by adding line totals on
// top of the already-correct server-rendered subtotal. The cart is fully
// rendered server-side, so we only need to kick off the upsell renderer.
// Defer one tick so renderRecommendations (declared later) is out of TDZ.
setTimeout(async function setupCart() {
  if (typeof renderRecommendations === "function") {
    await renderRecommendations();
  }
}, 0);

const shopifyCartFetch = async (url, body, method = "POST") => {
  body.sections = ["cart"];
  return fetch(url, {
    method,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
};

const dedupe = (arr) => {
  return arr.filter((item, index) => arr.indexOf(item) === index);
};

const getProductRecommendations = async (product_id) => {
  const response = await fetch(
    window.Shopify.routes.root +
      `recommendations/products?product_id=${product_id}&section_id=product-recommendations&limit=4`,
  );
  const html = await response.text();
  // parse the html and only return the inner li elements
  let parser = new DOMParser();
  let doc = parser.parseFromString(html, "text/html");
  let items = doc.querySelectorAll("div > div");
  let datasets = Array.from(items).map((item) => {
    const { dataset } = item;
    const out = {
      title: dataset.title,
      img: dataset.img,
      price: dataset.price,
      productId: dataset.productId,
      productUrl: dataset.productUrl,
      variantId: dataset.variantId,
    };
    return out;
  });
  return datasets;
};

function parsePriceString(priceStr) {
  if (typeof priceStr !== "string") return NaN;
  // Remove commas and whitespace, then parse as float
  return parseFloat(priceStr.replace(/,/g, "").trim());
}

const renderRecommendations = async () => {
  let MAX_RESULTS = 6;
  const recommendationPromises = [];
  const lineItemsProductIds = dedupe(
    Array.from(document.querySelectorAll(".cart-item")).map((item) =>
      item.getAttribute("cart-item-product-id"),
    ),
  );
  const cartUpsellsCopy = document.querySelector(".cart-upsells-copy");
  console.log("line item product ids", lineItemsProductIds);

  Promise.all(
    lineItemsProductIds.map((id) => {
      return getProductRecommendations(id);
    }),
  ).then((results) => {
    console.log({ results });
    let output = [];
    let idsAdded = [];
    while (output.length < MAX_RESULTS) {
      for (const resultSet of results) {
        let item = resultSet.shift();
        console.log(window.UPSELL_MAX, parsePriceString(item?.price), item);
        if (
          item &&
          !lineItemsProductIds.includes(item.productId) &&
          !idsAdded.includes(item.productId) &&
          (!window.UPSELL_MAX ||
            parsePriceString(item.price) <= window.UPSELL_MAX)
        ) {
          output.push(`
                        <li class="cart-upsell-item" data-variant-id="${item.variantId}" role="button" tabindex="0">
                            <div class="product-recommendations-cart-list-item">
                                <div class="upsell-item-image">
                                    <img src="${item.img}" alt="${item.title}" />
                                </div>
                                <span class="upsell-item-title">${item.title}</span>
                                <div class="upsell-item-price"><span>$${item.price}</span></div>
                            </div>
                        </li>
                    `);
          idsAdded.push(item.productId);
        }
        if (output.length >= MAX_RESULTS) {
          break;
        }
      }
      if (results.every((r) => r.length === 0)) {
        break;
      }
    }
    // sections/cart.liquid only renders the upsell markup inside its "cart has
    // items" branch, so #cart-upsells / .cart-upsells-list are absent whenever
    // the cart is empty. Bail out rather than throwing on .parentNode below.
    let cartUpsellsRoot = document.querySelector("#cart-upsells");
    let cartUpsells = document.querySelector(".cart-upsells-list");
    if (!cartUpsellsRoot || !cartUpsells) return;

    if (output.length) cartUpsellsRoot.classList.remove("needs-render");
    console.log({ idsAdded, output });
    if (idsAdded.length) {
      cartUpsells.innerHTML = dedupe(output).slice(0, MAX_RESULTS).join("");
      if (cartUpsellsCopy) cartUpsellsCopy.style.display = "";
    } else {
      cartUpsells.parentNode.style.display = "none";
    }
  });
};
window.renderRecommendations = renderRecommendations;

const renderRecommendationsZ = async () => {
  let MAX_RESULTS = 8;
  const product_ids = document
    .querySelector("#cart-upsells.needs-render")
    ?.getAttribute("data-product-ids")
    .split(",")
    .filter((id) => id.length);
  let recommendations = [];
  if (!product_ids) {
    return;
  }
  const recommendationPromises = [];
  let totalResults = 0;
  for (const id of product_ids) {
    recommendationPromises.push(
      fetch(
        window.Shopify.routes.root +
          `recommendations/products?product_id=${id}&section_id=product-recommendations&limit=4`,
      )
        .then((response) => response.text())
        .then((html) => {
          // parse the html and only return the inner li elements
          let parser = new DOMParser();
          let doc = parser.parseFromString(html, "text/html");
          let items = doc.querySelectorAll("li");
          totalResults += items.length;
          let itemsHtml = Array.from(items).map((item) => item.outerHTML);
          return itemsHtml;
        }),
    );
  }
  Promise.all(recommendationPromises).then((results) => {
    let output = [];
    console.log({ results });
    let cartLineItemIds = Array.from(
      document.querySelectorAll(".cart-item"),
    ).map((item) => item.getAttribute("cart-item-product-id"));
    if (totalResults < MAX_RESULTS) {
      output = results.flat();
    } else {
      // round robin through results to get a mix from each product
      let added = 0;
      let index = 0;
      while (added < MAX_RESULTS) {
        for (const resultSet of results) {
          if (
            resultSet[index] &&
            !cartLineItemIds.includes(
              $(resultSet[index]).attr("data-product-id"),
            )
          ) {
            output.push(resultSet[index]);
            added++;
            if (added >= MAX_RESULTS) {
              break;
            }
          }
        }
        index++;
      }
    }
    console.log("final output", output);
    output.length &&
      document.querySelector("#cart-upsells").classList.remove("needs-render");
    let cartUpsells = document.querySelector(".cart-upsells-list");
    cartUpsells.innerHTML = dedupe(output).slice(0, 4).join("");
  });

  console.log("rendering recommendations for ", product_ids);
};

// Legacy addToCart kept as a shim that forwards to the new SLJCart module so
// any external callers (themes, embedded snippets) keep working.
const addToCart = async (id, quantity, properties) => {
  if (window.SLJCart && typeof window.SLJCart.addItem === "function") {
    return window.SLJCart.addItem(id, quantity, properties);
  }
  console.warn("SLJCart not initialized yet");
};

// window.newAddToCart = newAddToCart;

async function postData(url = "", data = {}) {
  // Default options are marked with *
  const response = await fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  return response.json(); // parses JSON response into native JavaScript objects
}

// Legacy updateQ kept as a shim that forwards to the new SLJCart module.
async function updateQ(id, count) {
  if (window.SLJCart && typeof window.SLJCart.changeItem === "function") {
    return window.SLJCart.changeItem(id, count);
  }
  console.warn("SLJCart not initialized yet");
}

window.updateQ = updateQ;

//write an interaction observer that turns a class "in-view" when element intersects with middle 5% of the screen. run this on .thumb and .feature-grid .btn elements

function toggleInView(num = 0) {
  let items = document.querySelector(".shop-thumb");
  items?.classList.toggle("in-view");
  items = document.querySelector(".feature-grid .btn");
  items?.classList.toggle("in-view");
}

if (window.innerWidth < 768) {
  let observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // setTimeout(()=>entry.target.classList.add("in-view"), 1000);
          // observer.unobserve(entry.target);
        } else {
          setTimeout(() => entry.target.classList.remove("in-view"), 1000);
          // observer.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: "-40% 0px -40% 0px",
      threshold: 0.05,
    },
  );

  const handleTouchStart = (e) => {
    let parent = e.target.closest(".shop-thumb, .btn");
    if (parent) parent.classList.add("in-view");
  };
  const handleTouchEnd = (e) => {
    let parent = e.target.closest(".shop-thumb, .btn");
    if (parent) parent.classList.remove("in-view");
  };

  // Bind the IO + touch handlers to a thumb. Idempotent — flags via a
  // data attr so re-calling after dynamic injection (e.g. PDP recs
  // fetched into #shop-scroll) doesn't double-observe.
  function bindShopThumb(el) {
    if (!el || el.dataset.inViewBound === "1") return;
    el.dataset.inViewBound = "1";
    observer.observe(el);
    el.addEventListener("touchstart", handleTouchStart);
    el.addEventListener("touchend", handleTouchEnd);
  }

  // Public hook for code that injects new .shop-thumb / .feature-grid .btn
  // nodes (PDP recommendations, ajax-paginated collection grids, etc.).
  // Pass a root element to scope the query; defaults to document.
  window.bindNewShopThumbs = function (root) {
    (root || document)
      .querySelectorAll(".shop-thumb, .feature-grid .btn")
      .forEach(bindShopThumb);
  };

  // Initial pass for whatever's in the static DOM.
  document.addEventListener("DOMContentLoaded", function () {
    window.bindNewShopThumbs();
  });
  // Also run immediately in case DOMContentLoaded already fired.
  if (document.readyState !== "loading") window.bindNewShopThumbs();
}

(function () {
  if (window.innerWidth >= 768) return;

  let stillTimeout = null;
  const STILL_DELAY = 1000;

  const scheduleStill = () => {
    if (stillTimeout) clearTimeout(stillTimeout);
    stillTimeout = setTimeout(() => {
      document.body.classList.add("still");
      stillTimeout = null;
    }, STILL_DELAY);
  };

  const onScroll = () => {
    // user started scrolling — remove class and reset timer
    document.body.classList.remove("still");
    if (stillTimeout) clearTimeout(stillTimeout);
    scheduleStill();
  };

  // start the initial timer in case user doesn't scroll immediately
  scheduleStill();

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener(
    "touchstart",
    () => {
      document.body.classList.remove("still");
      if (stillTimeout) clearTimeout(stillTimeout);
    },
    { passive: true },
  );
})();
